import React from 'react';
import Modal from 'simple-react-modal';
import Dropzone from 'react-dropzone';

import { Formik, Form, ErrorMessage } from 'formik';

import { Add, Delete, Videocam } from '@material-ui/icons';

import './AddNewVideo.css';
import '../../../../../css/utils/flex.css';

class AddNewVideo extends React.Component {

  state = {
    uploadProgress: 0
  }

  formContainerRef = React.createRef();

  componentDidMount () {
    this.formContainerRef.current.focus();
  }

  onContainerKeyDown = event => {
    if (event.keyCode === 27 && event.target.tagName === 'DIV') {
      this.props.toggleVideoModal(false);
    }
  }

  validateForm = values => {
    const errors = {};
    if (!values.title) {
      errors.title = 'Please enter video title';
    } else if (values.title.length > 128) {
      errors.title = 'Video title too long.';
    }
    if (!values.description) {
      errors.description = 'Please enter video description';
    } else if (values.description.length > 512) {
      errors.description = 'Video description too long.';
    }
    if (!values.video || values.video.length === 0) {
      errors.video = 'Please select video file to upload';
    }
    return errors;
  }

  onAddVideo = values => {
    this.props.uploadVideo(values, this.onUploadProgress)
  }

  onUploadProgress = uploadProgress => {
    this.setState({ uploadProgress });
  }

  render () {
    return (
      <Modal
        onClose={() => this.props.toggleVideoModal(false)}
        show={true}
        containerStyle={{ width: '600px' }}
        containerClassName="modal-container">
        <div
          id="add-anchor-video"
          tabIndex={1}
          ref={this.formContainerRef}
          onKeyDown={this.onContainerKeyDown}>
          <div className="add-video-modal-header">
            <h3 className="modal-title">Upload video</h3>
          </div>
          <Formik
            initialValues={{ title: '', description: '', video: null }}
            onSubmit={this.onAddVideo}
            validate={this.validateForm}
            render={props => {
              let submitButtonStyles = {};
              if (!props.isValid || props.isSubmitting) {
                submitButtonStyles = {
                  opacity: '.4',
                  cursor: 'not-allowed'
                };
              }
              return (
                <Form autoComplete={'off'} className="add-video-form">
                  <div className="form-group">
                    <label htmlFor="anchor-video-add-title">Video Title</label>
                    <input
                      id="anchor-video-add-title"
                      name="title"
                      value={props.values.title}
                      onChange={props.handleChange}
                    />
                    <div className="error">
                      <ErrorMessage name="title" />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="anchor-video-add-desc">Description</label>
                    <textarea
                      id="anchor-video-add-desc"
                      name="description"
                      value={props.values.description}
                      onChange={props.handleChange}
                    />
                    <div className="error">
                      <ErrorMessage name="description" />
                    </div>
                  </div>
                  <Dropzone
                    onDrop={videos => props.setFieldValue('video', videos)}
                    onDropRejected={rejectedVideos => {
                      if (rejectedVideos && rejectedVideos.length > 0) {
                        props.setFieldTouched('video');
                      }
                    }}
                    accept={'video/*'}
                    multiple={false}
                    maxSize={5368709120}
                    >
                    {({
                      getRootProps,
                      getInputProps,
                      isDragAccept,
                      isDragReject
                    }) => {
                      const containerStyles = {};
                      if (isDragAccept) {
                        containerStyles.borderColor = '#02ac6f';
                      }
                      if (isDragReject) {
                        containerStyles.borderColor = '#ac020a';
                        containerStyles.backgroundColor = '#ffd1d1';
                      }
                      if (!!props.values.video && !!props.values.video[0] && !!props.values.video[0].name) {
                        containerStyles.display = 'none';
                      }
                      return (
                        <>
                          <section>
                            <p
                              className="upload-info-label"
                              style={(!!props.values.video && !!props.values.video[0] && !!props.values.video[0].name) ? { display: 'none' } : null}>
                              You can not select multiple files. Maximum file size is 5GB.
                            </p>
                            <div {...getRootProps()} className="dropzone" style={containerStyles}>
                              <input {...getInputProps()} name="video" />
                              <div className="dropzone-info-content">
                                <div className="dropzone-info-icon">
                                  <Add fontSize="inherit" />
                                </div>
                                <p>Click here to upload videos</p>
                              </div>
                            </div>
                          </section>
                          {
                            props.values.video &&
                            props.values.video[0] &&
                            props.values.video[0].name && (
                            <div className="file-preview">
                              <span className="file-icon">
                                <Videocam fontSize="large" />
                              </span>
                              <span className="filename">{props.values.video[0].name}</span>
                              <span className="remove-file-icon"
                                onClick={() => props.setFieldValue('video', null)}>
                                <Delete fontSize="large" />
                              </span>
                            </div>
                          )}
                          <div className="error">
                            <ErrorMessage name="video" />
                          </div>
                        </>
                    )}
                  }
                  </Dropzone>
                  {this.state.uploadProgress > 0 && (
                    <div className="upload-progress">
                      <span style={{ right: `${100 - this.state.uploadProgress}%` }} />
                    </div>
                  )}
                  <div className="buttons">
                    <button
                      disabled={props.isSubmitting}
                      type="submit"
                      className="submit-button"
                      style={submitButtonStyles}>
                      Publish
                    </button>
                    <button
                      type="button"
                      onClick={() => this.props.toggleVideoModal(false)}
                      className="cancel-button">
                      Cancel
                    </button>
                  </div>
                </Form>
              )
            }}
          />
        </div>
      </Modal>
    );
  }
}

export default AddNewVideo;